__turbopack_context__.v({
  "clearButton": "SearchInput-module-scss-module__NJWSya__clearButton",
  "container": "SearchInput-module-scss-module__NJWSya__container",
  "default": "SearchInput-module-scss-module__NJWSya__default",
  "iconButton": "SearchInput-module-scss-module__NJWSya__iconButton",
  "iconStart": "SearchInput-module-scss-module__NJWSya__iconStart",
  "input": "SearchInput-module-scss-module__NJWSya__input",
  "lg": "SearchInput-module-scss-module__NJWSya__lg",
  "md": "SearchInput-module-scss-module__NJWSya__md",
  "overlay": "SearchInput-module-scss-module__NJWSya__overlay",
  "page": "SearchInput-module-scss-module__NJWSya__page",
  "sm": "SearchInput-module-scss-module__NJWSya__sm",
  "submitButton": "SearchInput-module-scss-module__NJWSya__submitButton",
});
